<template>
  <div class="form">
    <div class="dx-fieldset">
      <div v-for="val in checkBoxValue" class="dx-field">
        <div class="dx-field-label">{{ val.label }}</div>
        <div class="dx-field-value">
          <DxCheckBox :value="false" :name="val.name" :ref="val.id" @value-changed="handleValueChange(val.id)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DxCheckBox } from 'devextreme-vue/check-box';
import {
  DxForm,

} from 'devextreme-vue/form';


export default {
  props: {
    checkList: Array,
    modelValue: {
      type: Array,
      default: [],
      required: true
    },

  },
  components: {
    DxCheckBox,
    DxForm,
  },
  data() {
    return {
      checkBoxValue: this.checkList.editorOptions.checkList,
      modelArr: [],
    }
  },
  methods: {
    handleValueChange(id) {
      //  const previousValue = e.previousValue;
      const newValue = this.$refs[id].instance.option("value");

      if (newValue) {
        //   console.log("checkvalue is ",id+this.$refs[id].instance.option("value"));
        //add new value to modelArr
        this.modelArr.push(id);
      }
      else {
        this.modelArr.splice(this.modelArr.indexOf(id), 1);
        console.log("Unchecked");
      }

      console.log("modelArr is ", this.modelArr);
      this.$emit('update:modelValue', this.modelArr);
    }
  },

  mounted() {   
    // console.log('value: ', val);
    // this.checkBoxValue = this.checkList;
    // console.log("checkList",this.checkList.editorOptions.checkList);
  },

}
</script>

<style></style>